import { apiClient } from '../api';

const platformApi = {
  listTenants: () =>
    apiClient.get('/api/admin/tenants').then(r => r.data),

  createTenant: (data) =>
    apiClient.post('/api/admin/tenants', data).then(r => r.data),

  deleteTenant: (tenantId) =>
    apiClient.delete(`/api/admin/tenants/${tenantId}`).then(r => r.data),

  listTenantMembers: (tenantId) =>
    apiClient.get(`/api/admin/tenants/${tenantId}/members`).then(r => r.data),
};

export default platformApi;
